import * as React from "react";
import BreadCrumbComponent from "../../components/BreadCrumbs";
import { getSx } from "./style";
import { Box, Typography } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useLocation } from "react-router-dom";

const FormDetail = ({ formData }) => {
  const classes = getSx();
  const navigateState = useLocation();
  const rowData = navigateState.state?.row;

  return (
    <>
      <BreadCrumbComponent
        heading1="Review Contact Form"
        heading2="Form Details"
      />
      <Box sx={classes.rightBoxContainer}>
        <Typography sx={{ ...classes.text, ...classes.name }}>
          Name: <span style={classes.textData}>{rowData?.name}</span>
        </Typography>
        <Typography sx={classes.text}>
          Email: <span style={classes.textData}>{rowData?.email}</span>
        </Typography>
        <Typography sx={classes.text}>
          Phone Number: <span style={classes.textData}>{rowData?.phone}</span>
        </Typography>
        <Typography sx={classes.text}>
          Description:{" "}
          <span style={classes.textData}>{rowData?.description}</span>
        </Typography>
        <Box sx={classes.contentBox}>
          <Typography sx={classes.text}>Images:</Typography>
          <Box sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "1rem",
            marginTop: "1rem",
          }}>
            {[
              rowData?.attachments?.map((item, index) => (
                <LazyLoadImage
                  data-wow-delay=".3s"
                  src={item}
                  effect="blur"
                  style={{
                    width: window.innerWidth < 900 ? "140px" : "160px",
                    height: window.innerWidth < 900 ? "140px" : "160px",
                    animationName: "fadeInUp",
                    animationDelay: "0.3s",
                    objectFit: "fill",
                    marginTop: "7px",
                  }}
                />
              )),
            ]}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default FormDetail;
